{
  "pt": {
    "modal": {
      "actions": {
        "add": "Atribuir este cliente a esta unidade",
        "approve": "Aprovar",
        "assign": "Atribuir a esta unidade",
        "assign_SUP": "Atribuir a este projeto",
        "block": "Bloquear",
        "cancel": "Cancelar",
        "close": "Fechar",
        "contact_ziggu": "Contactar Ziggu",
        "deactivate": "Desativar",
        "giveAccess": "Dar acesso em linha",
        "goBack": "Voltar atrás",
        "gotIt": "Já está",
        "loading": "A carregar",
        "next": "Seguinte",
        "no": "Não",
        "reactivate": "Reativar",
        "remove": "Eliminar",
        "select_rights": "Selecionar direitos",
        "send": "Enviar convite por e-mail",
        "sendFeedback": "Enviar comentários",
        "skip": "Saltar",
        "submit": "Enviar",
        "submitting": "A enviar",
        "uploading": "A carregar",
        "yes": "Sim"
      },
      "labels": {
        "areYouSure": "Tem a certeza?",
        "areYouSureDelete": "Tem a certeza de que pretende eliminar {object}?",
        "assignCustomerToUnitMessagePermanently": "{customer} já foi convidado para a plataforma. Ao atribuir esta unidade, o acesso é imediato.",
        "assignCustomerToUnitTitlePermanently": "Atribuir {customer} permanentemente a {unit}?",
        "assignTodoListToLevel": "Está prestes a atribuir a lista de tarefas {object} ao nível {level}. Continuar?",
        "dangerZone": "Zona de perigo",
        "deactivate": "Tem a certeza de que pretende desativar o {contact}?",
        "deactivateMessage": "O utilizador não terá acesso à plataforma. Todos os documentos, perguntas frequentes, anúncios, tarefas, conversas, etc. relacionados com este utilizador continuarão acessíveis na plataforma para outros utilizadores.",
        "deleteCustomerMessage": "Esta pessoa perderá todo o acesso à plataforma e, por conseguinte, todos os documentos, perguntas frequentes, conversas, notícias, etc.",
        "deleteCustomerTitle": "Tem a certeza de que pretende eliminar o cliente {customer}?",
        "deleteDecisionsBulk": "Tem a certeza de que pretende eliminar {amount} decisões?",
        "deleteDeniedMessage": "Este cliente tem pelo menos uma unidade atribuída. Remova primeiro as unidades atribuídas antes de eliminar este cliente.",
        "deleteDeniedTitle": "Eliminar não permitido para {customer}",
        "deleteEmployeeIntercom": "Contacte-nos através do Intercom e ajudá-lo-emos de imediato!",
        "deleteEmployeeMessage": "Este utilizador perderá todo o acesso à plataforma. Todos os documentos, bilhetes e anúncios relacionados com este utilizador serão igualmente eliminados.",
        "deleteEmployeeQuestion": "Eliminar em vez disso?",
        "deleteEmployeeSubMessage": "Se pretender manter todas as informações deste utilizador, desative-o.",
        "deleteEmployeeTitle": "Tem a certeza de que pretende remover {employee}?",
        "deleteLeadMessage": "Se este lead estava interessado numa unidade, perderá esses dados. Se o lead tiver comprado uma unidade e se tiver tornado cliente, manterá o cliente e os seus dados.",
        "deleteLeadTitle": "Tem a certeza de que pretende eliminar o lead {lead}?",
        "goToProposal": "Ir para {proposal_name}",
        "gotItMessage": "Ok, já está",
        "loading": "O ficheiro está a ser carregado, aguarde. O ecrã de carregamento fechará automaticamente.",
        "noUnitSelected": "Uh oh! Nenhuma unidade selecionada",
        "noUnitSelectedMessage": "Selecione a unidade sobre a qual pretende comunicar um defeito",
        "notPossible": "Não é possível",
        "ohNo": "Oh não!",
        "reactivate": "Tem a certeza de que pretende reativar {contact}?",
        "reactivateMessage": "O utilizador voltará a ter acesso à plataforma.",
        "removeCustomerDeleteInfo1": "As conversas em que o cliente participou serão eliminadas",
        "removeCustomerDeleteInfo2": "Os inquéritos relacionados com esta unidade serão eliminados",
        "removeCustomerDeleteInfo3": "Os documentos carregados pelo cliente no âmbito de conversações, decisões ou propostas serão eliminados. Isto inclui também as versões assinadas dos documentos.",
        "removeCustomerKeepInformation": "Os documentos gerais e qualquer outro conteúdo publicado nesta unidade manter-se-ão inalterados e serão visíveis para um novo cliente.  ",
        "removeCustomerMessage": "{customer} teve acesso total a esta unidade. Se remover o cliente, qualquer conteúdo de {customer} será eliminado. Isto significa que… ",
        "removeCustomerMessageNth": "Se remover este cliente, o conteúdo criado por {customer} será desanexado de {customer}. Isto significa que o conteúdo será preservado, mas deixará de ter origem em {customer}.",
        "removeMessage": "Tem a certeza de que pretende remover {level}? Ao fazer isto, perderá todos os dados guardados relacionados com este {type}. Não será possível recuperá-los posteriormente.",
        "removeTitle": "Remover {record_name}",
        "revokeAccessMessage": "Está prestes a revogar o acesso de {customer} a esta unidade. Se esta for a única unidade atribuída ao cliente, este perderá o acesso total à plataforma. ",
        "setCustomerMessage": "Ótimo! Está prestes a atribuir {customer} a {unit}. No entanto, {customer} ainda não terá acesso total à plataforma. Mas pode alterar isso concedendo acesso depois de ter atribuído esta unidade. ",
        "setCustomerMessageSUP": "Ótimo! Está prestes a atribuir {customer} a {unit}. No entanto, {customer} ainda não terá acesso total à plataforma. Mas pode alterar isso concedendo acesso depois de ter atribuído este projeto. ",
        "setCustomerTitle": "Atribuir {customer} a {unit}?",
        "setVisibleMessage": "Esplêndido! Está prestes a dar a {customer} acesso total a documentos partilhados e a informações relacionadas com {unit}. ",
        "setVisibleTitle": "Dar a {customer} acesso em linha a {unit}?",
        "this": "este",
        "typeHere": "Escreva aqui...",
        "typeToConfirm": "Digite \"{confirmationInput}\" para confirmar",
        "warningAreYouSure": "CUIDADO! Tem a certeza?",
        "warningDeleteDocument": "{file_name} foi carregado num {attachable_type}. Se o remover aqui, também o removerá do {attachable_type}",
        "warningDeleteDocumentApprovedProposal": "{file_name} é um documento que pertence a uma proposta aprovada e não pode ser eliminado neste estado. A sua eliminação implicaria a anulação da aprovação da proposta",
        "warningDeleteDocumentLevel": "{file_name} foi carregado na pasta {level_type}. Removê-lo aqui também o removerá da pasta {level_type} ",
        "warningDeleteDocumentMulti": "Alguns dos documentos que pretende eliminar foram carregados numa decisão ou numa conversa. Se os remover aqui, também os removerá da decisão ou da conversa"
      }
    }
  }
}
